import React, { useState } from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import Checkbox from "../../../components/Checkbox";
import Loader from "../../../components/Loader";
import Row from "./Row";

// data
import { customers } from "../../../mocks/customers";

export const integrations = [
	{
		id: 0,
		title: "Google Analytics",
		subtitle: "@username",
		description:
			"Google Analytics service is part of the Google Marketing Platform and is available for free to anyone with a Google account.",
		avatar: "/images/integration/analytics.png",
		email: "chelsie@BrandBox.net",
	},
	{
		id: 1,
		title: "HelpDesk",
		subtitle: "@username",
		description:
			"Integrate HelpDesk and LiveChat to create a powerful customer support platform. Simplify your customer support tasks. Focus on increasing sales and customer satisfaction levels.",
		avatar: "/images/integration/helpdesk.png",
		email: "chelsie@BrandBox.net",
	},
	{
		id: 2,
		title: "Stripe",
		subtitle: "@username",
		description: "A fully integrated suite of financial and payments products.",
		avatar: "/images/integration/stripe.png",
		email: "chelsie@BrandBox.net",
	},
	// {
	// 	id: 3,
	// 	title: "UPS Tracking",
	// 	subtitle: "@username",
	// 	description:
	// 		"Track one or multiple packages with UPS Tracking, use your tracking number to track the status of your package.",
	// 	avatar: "/images/integration/ups.png",
	// 	email: "chelsie@BrandBox.net",
	// },
];

const Table = ({ className, activeTable, setActiveTable, setData }) => {
	const [chooseAll, setСhooseAll] = useState(false);
	const [activeId, setActiveId] = useState(customers[0].id);

	const [selectedFilters, setSelectedFilters] = useState([]);

	const handleChange = (id) => {
		if (selectedFilters.includes(id)) {
			setSelectedFilters(selectedFilters.filter((x) => x !== id));
		} else {
			setSelectedFilters((selectedFilters) => [...selectedFilters, id]);
		}
	};

	return (
		<div className={cn(styles.wrapper, className)}>
			<div className={cn(styles.table)}>
				<div className={cn(styles.row, { [styles.active]: activeTable })}>
					<div className={styles.col}>
						{/* <Checkbox
							className={styles.checkbox}
							value={chooseAll}
							onChange={() => setСhooseAll(!chooseAll)}
						/> */}
					</div>
					<div className={styles.col}>External tools</div>
					<div className={styles.col}>Description</div>
					{/* <div className={styles.col}>Purchase</div> */}
					{/* <div className={styles.col}>Comments</div>
					<div className={styles.col}>Likes</div> */}
				</div>
				{integrations.map((x, index) => (
					<Row
						item={x}
						key={index}
						activeTable={activeTable}
						setActiveTable={setActiveTable}
						activeId={activeId}
						setActiveId={setActiveId}
						value={selectedFilters.includes(x.id)}
						setData={setData}
						onChange={() => handleChange(x.id)}
					/>
				))}
			</div>
		</div>
	);
};

export default Table;
